export default __webpack_public_path__ + "static/media/spheres.fd2c6638.mp3";